import LoadingScreen from '../components/LoadingScreen';
import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { useAppContext } from '../context/AppContext';

const CITIES = ['Казань', 'Зеленодольск', 'Волжск'];
const DISTRICTS = ['Мирный', 'Город', 'Зеленый дол'];

const todayISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
const formatDate = (iso) => { if (!iso) return ''; const [y,m,d] = iso.split('-'); return `${d}.${m}.${y}`; };

export default function AdminCreateOrderScreen() {
  const { user } = useAppContext();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const [selectedProductId, setSelectedProductId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [exchangeQty, setExchangeQty] = useState('');
  const [deliveryDate, setDeliveryDate] = useState(todayISO());
  const [city, setCity] = useState(null);
  const [district, setDistrict] = useState(null);
  const [form, setForm] = useState({ street: '', house: '', entrance: '', floor: '', apartment: '', phone: '', comment: '' });
  const [errors, setErrors] = useState({});
  const [customPrice, setCustomPrice] = useState(null);
  const [customPriceInput, setCustomPriceInput] = useState('');
  const [priceModalVisible, setPriceModalVisible] = useState(false);

  useEffect(() => {
    api.products.list().then(d => setProducts(d || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const selectedProduct = products.find(p => p.id === selectedProductId) || null;
  const exchangeCount = Number(exchangeQty || 0);
  const autoTotal = selectedProduct ? Math.max(0, selectedProduct.price * quantity - exchangeCount * 280) : 0;
  const total = customPrice !== null ? customPrice : autoTotal;

  const set = (field, value) => { setForm(p => ({ ...p, [field]: value })); if (errors[field]) setErrors(p => ({ ...p, [field]: null })); };
  const handlePhone = (v) => { let c = v.replace(/[^\d+]/g, ''); if (c.startsWith('8')) c = '+7' + c.slice(1); if (c.startsWith('7') && !c.startsWith('+7')) c = '+' + c; if (c.length > 12) return; set('phone', c); };
  const changeQty = (d) => { const n = Math.max(1, quantity + d); setQuantity(n); if (exchangeQty !== '' && Number(exchangeQty) > n) setExchangeQty(String(n)); };

  const validate = () => {
    const e = {};
    if (!selectedProduct) e.product = 'Выберите бутыль';
    if (!form.street.trim()) e.street = 'Введите улицу';
    if (!form.house.trim()) e.house = 'Введите номер дома';
    if (!form.phone.trim()) e.phone = 'Введите телефон';
    else if (!/^\+7\d{10}$/.test(form.phone)) e.phone = 'Формат: +79991234567';
    if (!deliveryDate) e.deliveryDay = 'Выберите день доставки';
    if (!city) e.city = 'Выберите город доставки';
    if (city === 'Зеленодольск' && !district) e.district = 'Выберите район';
    if (exchangeQty === '') e.exchangeQty = 'Укажите бутыли на обмен (0 если нет)';
    else if (Number(exchangeQty) > quantity) e.exchangeQty = 'Не может быть больше количества';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submitOrder = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      const addr = [form.street.trim(), form.house.trim(), form.entrance.trim() ? `подъезд ${form.entrance}` : '', form.floor.trim() ? `этаж ${form.floor}` : '', form.apartment.trim() ? `кв. ${form.apartment}` : ''].filter(Boolean).join(', ');
      await api.orders.create({ brand: selectedProduct.brand, volume: selectedProduct.volume, price: selectedProduct.price, address: addr, phone: form.phone, quantity, exchange_count: exchangeCount, total_price: total, delivery_day: deliveryDate, city, district: district || null, comment: form.comment.trim() || null });
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setSelectedProductId(null); setQuantity(1); setExchangeQty(''); setCity(null); setDistrict(null); setDeliveryDate(todayISO());
        setForm({ street: '', house: '', entrance: '', floor: '', apartment: '', phone: '', comment: '' }); setErrors({}); setCustomPrice(null);
      }, 2000);
    } catch { alert('Нет соединения с сервером'); }
    finally { setSubmitting(false); }
  };

  if (loading) return <LoadingScreen />;

  return (
    <div style={{ padding: '0 16px 100px' }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--primary)', marginTop: 16 }}>Оформление заказа</h1>
      <p style={{ fontSize: 13, color: 'var(--text-light)', marginBottom: 16 }}>Выберите бутыль и заполните данные клиента</p>

      {success && <div style={{ background: '#4CAF5022', border: '1.5px solid #4CAF50', borderRadius: 12, padding: 14, textAlign: 'center', fontWeight: 700, color: '#4CAF50', marginBottom: 16 }}>✅ Заказ создан!</div>}

      <form onSubmit={submitOrder}>
        {/* Выбор продукта */}
        <label style={labelStyle}>Выбор бутыли</label>
        {products.map(item => {
          const selected = item.id === selectedProductId;
          return (
            <div key={item.id} onClick={() => { setSelectedProductId(item.id); setErrors(p => ({ ...p, product: null })); setCustomPrice(null); }}
              style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'var(--card)', borderRadius: 12, border: `1.5px solid ${selected ? 'var(--primary)' : 'var(--border)'}`, padding: 12, marginBottom: 8, cursor: 'pointer' }}>
              <span style={{ fontSize: 28 }}>{item.emoji || '💧'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, color: 'var(--primary)', fontSize: 15 }}>{item.brand}</div>
                <div style={{ fontSize: 13, color: 'var(--text-light)' }}>{item.volume}</div>
              </div>
              <span style={{ fontWeight: 700, fontSize: 15 }}>{item.price} ₽</span>
            </div>
          );
        })}
        {errors.product && <p style={errorStyle}>⚠ {errors.product}</p>}

        {/* Количество */}
        <label style={labelStyle}>Количество</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          <button type="button" onClick={() => changeQty(-1)} style={qtyBtn}>−</button>
          <input type="number" min={1} max={999} value={quantity} onChange={e => { const n = parseInt(e.target.value); if (!isNaN(n) && n >= 1) { setQuantity(n); if (exchangeQty !== '' && Number(exchangeQty) > n) setExchangeQty(String(n)); } }}
            style={{ width: 52, height: 36, textAlign: 'center', fontSize: 16, fontWeight: 700, background: 'var(--input-bg)', border: '1.5px solid var(--border)', borderRadius: 10, color: 'var(--text)', outline: 'none' }} />
          <button type="button" onClick={() => changeQty(1)} style={qtyBtn}>+</button>
          {selectedProduct && (
            <button type="button" onClick={() => { setCustomPriceInput(customPrice !== null ? String(customPrice) : String(autoTotal)); setPriceModalVisible(true); }}
              style={{ background: 'none', color: 'var(--primary)', fontWeight: 700, fontSize: 14, cursor: 'pointer', marginLeft: 8 }}>
              Сумма: {total} ₽ ✏️
            </button>
          )}
        </div>

        {/* Обмен */}
        <label style={labelStyle}>Бутыли на обмен</label>
        <input type="number" min={0} placeholder="0" value={exchangeQty}
          onChange={e => { const v = e.target.value; if (Number(v) <= quantity) { setExchangeQty(v); setErrors(p => ({ ...p, exchangeQty: null })); } }}
          style={{ ...inputStyle, borderColor: errors.exchangeQty ? '#FF3B30' : 'var(--border)' }} />
        {errors.exchangeQty && <p style={errorStyle}>⚠ {errors.exchangeQty}</p>}
        <p style={{ fontSize: 13, color: 'var(--text-light)', marginBottom: 4 }}>Скидка: {exchangeCount * 280} ₽ (280 ₽ × {exchangeCount})</p>

        {/* Город */}
        <label style={labelStyle}>Город доставки</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
          {CITIES.map(c => <button key={c} type="button" onClick={() => { setCity(c); setDistrict(null); setErrors(p => ({ ...p, city: null })); }}
            style={{ flex: 1, padding: '10px 4px', borderRadius: 10, border: '1.5px solid', borderColor: city === c ? 'var(--primary)' : 'var(--border)', background: city === c ? 'var(--primary)' : 'var(--card)', color: city === c ? '#fff' : 'var(--text)', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>{c}</button>)}
        </div>
        {errors.city && <p style={errorStyle}>⚠ {errors.city}</p>}

        {city === 'Зеленодольск' && (
          <>
            <label style={labelStyle}>Район</label>
            <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
              {DISTRICTS.map(d => <button key={d} type="button" onClick={() => { setDistrict(d); setErrors(p => ({ ...p, district: null })); }}
                style={{ flex: 1, padding: '10px 4px', borderRadius: 10, border: '1.5px solid', borderColor: district === d ? 'var(--primary)' : 'var(--border)', background: district === d ? 'var(--primary)' : 'var(--card)', color: district === d ? '#fff' : 'var(--text)', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>{d}</button>)}
            </div>
            {errors.district && <p style={errorStyle}>⚠ {errors.district}</p>}
          </>
        )}

        {/* Адрес */}
        {[['Улица *', 'street', 'ул. Ленина', errors.street], ['Дом *', 'house', '15', errors.house], ['Подъезд', 'entrance', '2', null], ['Этаж', 'floor', '5', null], ['Квартира', 'apartment', '12', null]].map(([lbl, field, ph, err]) => (
          <div key={field}>
            <label style={labelStyle}>{lbl}</label>
            <input placeholder={ph} value={form[field]} onChange={e => set(field, e.target.value)}
              style={{ ...inputStyle, borderColor: err ? '#FF3B30' : 'var(--border)' }} />
            {err && <p style={errorStyle}>⚠ {err}</p>}
          </div>
        ))}

        {/* Телефон */}
        <label style={labelStyle}>Телефон</label>
        <input type="tel" placeholder="+79991234567" value={form.phone} onChange={e => handlePhone(e.target.value)}
          style={{ ...inputStyle, borderColor: errors.phone ? '#FF3B30' : 'var(--border)' }} />
        {errors.phone && <p style={errorStyle}>⚠ {errors.phone}</p>}

        {/* Дата */}
        <label style={labelStyle}>День доставки</label>
        <input type="date" value={deliveryDate} min={todayISO()} onChange={e => { setDeliveryDate(e.target.value); setErrors(p => ({ ...p, deliveryDay: null })); }}
          style={{ ...inputStyle, borderColor: errors.deliveryDay ? '#FF3B30' : 'var(--border)' }} />
        {errors.deliveryDay && <p style={errorStyle}>⚠ {errors.deliveryDay}</p>}

        {/* Комментарий */}
        <label style={labelStyle}>Комментарий</label>
        <textarea placeholder="Комментарий к заказу" value={form.comment} onChange={e => { if (e.target.value.length <= 250) set('comment', e.target.value); }}
          style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }} />

        <button type="submit" disabled={submitting} style={{ display: 'block', width: '100%', padding: 14, borderRadius: 14, background: 'var(--primary)', color: '#fff', fontSize: 16, fontWeight: 700, marginTop: 16, cursor: 'pointer', opacity: submitting ? 0.6 : 1 }}>
          {submitting ? 'Создание...' : 'Создать заказ'}
        </button>
      </form>

      {/* Модал ручной цены */}
      {priceModalVisible && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setPriceModalVisible(false)}>
          <div style={{ background: 'var(--card)', borderRadius: 16, padding: 24, width: '80%', maxWidth: 320 }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontWeight: 700, marginBottom: 4 }}>Изменить сумму</h3>
            <p style={{ fontSize: 13, color: 'var(--text-light)', marginBottom: 16 }}>Авто: {autoTotal} ₽</p>
            <input type="number" value={customPriceInput} onChange={e => setCustomPriceInput(e.target.value)} autoFocus
              style={{ display: 'block', width: '100%', textAlign: 'center', fontSize: 24, fontWeight: 700, background: 'var(--bg)', border: '1.5px solid var(--border)', borderRadius: 10, padding: 10, color: 'var(--text)', outline: 'none', marginBottom: 16 }} />
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setCustomPrice(null); setCustomPriceInput(''); setPriceModalVisible(false); }}
                style={{ flex: 1, padding: 10, borderRadius: 10, border: '1.5px solid var(--border)', background: 'none', color: 'var(--text-light)', fontWeight: 600, cursor: 'pointer' }}>Сбросить</button>
              <button onClick={() => { const n = parseInt(customPriceInput, 10); if (!isNaN(n) && n >= 0) setCustomPrice(n); setPriceModalVisible(false); }}
                style={{ flex: 1, padding: 10, borderRadius: 10, background: 'var(--primary)', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Сохранить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const centered = { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh', color: 'var(--text-light)' };
const labelStyle = { display: 'block', fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 8, marginTop: 12 };
const inputStyle = { display: 'block', width: '100%', background: 'var(--input-bg)', borderRadius: 12, padding: '12px 16px', fontSize: 15, color: 'var(--text)', border: '1.5px solid var(--border)', outline: 'none', marginBottom: 4 };
const errorStyle = { fontSize: 13, color: '#FF3B30', marginBottom: 8 };
const qtyBtn = { width: 36, height: 36, borderRadius: 10, background: 'var(--primary)', color: '#fff', fontSize: 20, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' };
